import { IPipelineContext } from './pipeline-context';
import { IPipelineEndpoint } from './pipeline-endpoint';

export interface IPipelineElement extends IPipelineEndpoint {
  parent: string;
  execute(context: IPipelineContext): Promise<PipelineResult>;
}

export interface PipelineResult {
  jobDone: boolean; // for easier debugging we flag elements that did not finish as expected
  contextId: string;
  [key: string]: unknown; // allow extra properties
}
